export default __webpack_public_path__ + "static/force-usa-cover-small-94b10f5e5cb725a53d7b0cb4671e396c.png";